<div *ngIf="debate">
  <lms-modal #cancelDebateModal>
    <div class="gl-modal__header">
      <div class="gl-modal__title">
        {{ 'debates.messages.cancelQuestion' | translate }}
      </div>
      <div class="gl-modal__close" (click)="closeCancelDebateModal()">
        <span class="glicon-close"></span>
      </div>
    </div>
    <div>
      <lms-dynamic-form
        #dynamicForm
        [questions]="questions"
        [action]="'debate.detail'"
        [options]="{ submitLabel: 'actions.yes', disableCard: true }"
        (submit)="onSubmit($event)"
      >
        <gl-button
          color-secondary
          [text]="'actions.no' | translate"
          (onClick)="closeCancelDebateModal()"
          form-actions-before
        ></gl-button>
      </lms-dynamic-form>
    </div>
  </lms-modal>
  <h1 class="h1 margin-bottom-none">{{ 'nouns.debate' | translate }}</h1>
  <lms-toolbar> </lms-toolbar>
  <div class="row">
    <!-- Dashboard chips  -->
    <lms-widget-container class="col s2" [widget]="seasonsWidget"></lms-widget-container>

    <lms-widget-container class="col s3" [widget]="votesWidget"></lms-widget-container>

    <lms-widget-container class="col s3" [widget]="opinionsWidget"></lms-widget-container>

    <lms-widget-container class="col s4" [widget]="actionsWidget"></lms-widget-container>
  </div>
  <div class="row" id="opinions">
    <div *ngIf="questionInfo && questionInfo.choices != undefined">
      <ul class="list table-row">
        <li class="heading">{{ debate.questionTitle }}</li>
        <li *ngFor="let choices of questionInfo.choices; let i = index" class="padding-left">
          <div
            [ngClass]="{
              'green-text': questionInfo.choices[i].isCorrect,
              'red-text': !questionInfo.choices[i].isCorrect
            }"
          >
            {{ questionInfo.choices[i].text }}
          </div>
        </li>
      </ul>
    </div>
    <lms-debate-opinions-list [opinions]="debate.debate"></lms-debate-opinions-list>
  </div>
</div>
